
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.625 9.75A1.877 1.877 0 016.75 7.875C6.75 6.841 7.59 6 8.625 6c1.034 0 1.875.84 1.875 1.875 0 1.034-.84 1.875-1.875 1.875zm0-3c-.62 0-1.125.505-1.125 1.125S8.005 9 8.625 9 9.75 8.495 9.75 7.875 9.245 6.75 8.625 6.75z","fill":"#FF9F43"}}),_c('path',{attrs:{"d":"M13.875 8.25h-3.75a.375.375 0 110-.75h3.75c.62 0 1.125-.505 1.125-1.125v-4.5c0-.62-.505-1.125-1.125-1.125h-10.5c-.62 0-1.125.505-1.125 1.125v4.5c0 .62.505 1.125 1.125 1.125h3.75a.375.375 0 010 .75h-3.75A1.877 1.877 0 011.5 6.375v-4.5C1.5.841 2.34 0 3.375 0h10.5c1.034 0 1.875.84 1.875 1.875v4.5c0 1.034-.84 1.875-1.875 1.875zm-5.25 8.25a.375.375 0 01-.375-.375v-6.75a.375.375 0 01.75 0v6.75a.375.375 0 01-.375.375z","fill":"#FF9F43"}}),_c('path',{attrs:{"d":"M11.625 18h-6a.375.375 0 01-.375-.375c0-1.069 1.451-1.875 3.375-1.875S12 16.556 12 17.625a.375.375 0 01-.375.375zm-5.45-.75h4.9c-.372-.401-1.3-.75-2.45-.75-1.152 0-2.078.349-2.45.75zM13.125 3h-9a.375.375 0 110-.75h9a.375.375 0 010 .75zm-1.5 1.5h-6a.375.375 0 110-.75h6a.375.375 0 010 .75z","fill":"#FF9F43"}})])
          )
        }
      }
    